module.exports = __webpack_public_path__ + "img/chickmaster_egg_icon.c45b2c5b.png";